import { ColumnDef } from '@tanstack/react-table';

export function getCellSize<T>(cell: ColumnDef<T>) {
  return {
    width: `${cell.size}%`,
    minWidth: `${cell.minSize}px`,
    maxWidth: `${cell.maxSize}px`
  };
}
